import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import NavBar from './components/nav';
import Footer from './components/Footer';
import carouselImage1 from '../assets/img/carousel.jpg';
import carouselImage2 from '../assets/img/carousel1.jpg';
import carouselImage3 from '../assets/img/carousel2.jpg';
import carouselImage4 from '../assets/img/carousel3.jpg';
import carouselImage5 from '../assets/img/carousel4.jpeg';
import Event1 from '../assets/img/evenements/1.jpg';
import Event2 from '../assets/img/evenements/2.jpg';
import Event3 from '../assets/img/evenements/3.jpg';
import Event4 from '../assets/img/evenements/4.jpg';
import Event5 from '../assets/img/evenements/5.JPG';
import Event6 from '../assets/img/evenements/6.jpg';
import Event7 from '../assets/img/evenements/7.JPG';
import Event8 from '../assets/img/evenements/8.jpg';
import Event9 from '../assets/img/evenements/9.jpg';
import Event10 from '../assets/img/evenements/10.jpg';
import festival from '../assets/img/Festival/festival2.jpg';
import festival1 from '../assets/img/Festival/festival5.jpg';
import cultur from '../assets/img/Journées_culturelles/culture1.jpg';
import cultur1 from '../assets/img/Journées_culturelles/culture8.jpg';
import congo from '../assets/img/connaitre_Congo/congo6.jpg';
import congo1 from '../assets/img/connaitre_Congo/congo7.jpg';
import CustomCursor from './components/CustomCursor'; // Importez le composant
import BtnFlottant from "./components/BtnFlottant"; // Import du composant
import festival1bis from '../assets/img/MAJ/1.jpg';
import festival2 from '../assets/img/MAJ/2.jpg';
import festival3 from '../assets/img/MAJ/3.jpg';
import festival4 from '../assets/img/MAJ/4.jpg';
import festival5 from '../assets/img/MAJ/5.jpg';
import festival6 from '../assets/img/MAJ/6.jpg';
import festival7 from '../assets/img/MAJ/7.jpg';
import festival8 from '../assets/img/MAJ/8.jpg';
import festival9 from '../assets/img/MAJ/9.jpg';
import festival10 from '../assets/img/MAJ/10.jpg';
import festival11 from '../assets/img/MAJ/11.jpg';
import festival12 from '../assets/img/MAJ/12.jpg';
import festival13 from '../assets/img/MAJ/13.jpg';
import festival14 from '../assets/img/MAJ/14.jpg';
import festival15 from '../assets/img/MAJ/15.jpg';
import festival16 from '../assets/img/MAJ/16.jpg';
import festival17 from '../assets/img/MAJ/17.jpg';



const Evenement = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const carouselImages = [
    carouselImage1,
    carouselImage2,
    carouselImage3,
    carouselImage4,
    carouselImage5,
  ];

  // Fonction pour passer à la diapositive suivante
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === carouselImages.length - 1 ? 0 : prev + 1));
  };

  // Fonction pour passer à la diapositive précédente
  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? carouselImages.length - 1 : prev - 1));
  };

  // Effet pour le défilement automatique
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000); // Change de diapositive toutes les 5 secondes

    // Nettoyer l'intervalle lorsque le composant est démonté
    return () => clearInterval(interval);
  }, [currentSlide]); // Dépendance sur currentSlide pour éviter les bugs

  // Revenir en haut de la page après le chargement
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll vers le haut de la page
  }, []); // Le tableau vide [] signifie que cela s'exécute une fois après le premier rendu

  return (
    <div className="overflow-x-hidden">
      <CustomCursor />
      <NavBar />

      {/* Header Carousel - Enhanced */}
      <motion.header
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative h-[600px]"
      >
        <div className="relative w-full h-full overflow-hidden">
          {carouselImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 w-full h-full transition-opacity duration-700 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/30 flex justify-center items-center">
                <div className="text-center text-white max-w-4xl px-6">
                  <motion.h1
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.3, duration: 0.8 }}
                    className="text-3xl md:text-5xl font-bold leading-tight"
                  >
                    NOS DIFFERENTS <span className="text-orange-400 block mt-2">EVENEMENTS</span>
                  </motion.h1>
                  <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.8 }}
                    className="mt-6 text-xl md:text-2xl font-light"
                  >
                    Découvrez nos événements pour célébrer, partager et bâtir un avenir meilleur pour le Congo.
                  </motion.p>
                  {/* <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="mt-8 px-8 py-3 bg-orange-400 text-white text-lg rounded-full hover:bg-orange-500 transition-all duration-300 shadow-lg"
                  >
                    Nous découvrir
                  </motion.button> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </motion.header>

      {/* Utilisation du composant FloatingButtons */}
      <BtnFlottant />

      {/* Events Section - Enhanced */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="py-20 bg-gradient-to-r from-orange-400 via-orange-500 to-pink-500"
      >
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-5xl font-bold mb-6 text-white">EVENEMENTS</h2>
          <p className="text-xl text-white/90 mb-12 max-w-3xl mx-auto">
            Ce sont des moments exceptionnels et inoubliables qui ont marqué la vie de notre association,
            de sa création à nos jours. Nous faisons connaitre le Congo par la découverte de ses hommes, de ses institutions, de 
            ses saveurs, de ses couleurs.
          </p>
          <div className="flex overflow-x-auto mt-6 snap-x snap-mandatory pb-8 gap-6">
            {[Event1, Event2, Event3, Event4, Event5, Event6, Event7, Event8, Event9, Event10].map((image, index) => (
              <motion.div
                whileHover={{ scale: 1.02 }}
                key={index}
                className="min-w-full flex-shrink-0 snap-center"
              >
                <div className="relative w-full h-[500px] overflow-hidden rounded-2xl shadow-2xl">
                  <img 
                    src={image} 
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-110" 
                    alt={`Événement ${index + 1}`} 
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent"></div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      {/* Festival Section - Enhanced */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="py-20 bg-gradient-to-r from-blue-600 to-indigo-700"
      >
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-12 text-white">Découvrez notre parcours</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
              <div className="p-6 text-white">
                <h3 className="text-xl font-semibold mb-3">Festival des rendez-vous de l'erdre</h3>
                <p className="text-white/80">Festival des rendez-vous de l'erdre, journée curturelle du Congo, découverte du Congo.</p>
              </div>
            </motion.div>

            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival1} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 2" />
              </div>
              <div className="p-6 text-white">
                <h3 className="text-xl font-semibold mb-3">Découverte du Congo</h3>
                <p className="text-white/80">Découverte du Congo au travers un large public.</p>
              </div>
            </motion.div>

            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={cultur} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 3" />
              </div>
              <div className="p-6 text-white">
                <h3 className="text-xl font-semibold mb-3">Les journées culturelles du Congo</h3>
                <p className="text-white/80">Permettent de réaliser la vitrine du Congo à Nantes et sa richesse culturelle.</p>
              </div>
            </motion.div>

            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={cultur1} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
              <div className="p-6 text-white">
                <h3 className="text-xl font-semibold mb-3">Journée culturelle du Congo</h3>
              </div>
            </motion.div>

            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={congo} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 2" />
              </div>
              <div className="p-6 text-white">
                <h3 className="text-xl font-semibold mb-3">Echange et partage dans la communauté Congolaise.</h3>
              </div>
            </motion.div>

            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={congo1} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 3" />
              </div>
              <div className="p-6 text-white">
                <h3 className="text-xl font-semibold mb-3">Pensons aussi au Congo</h3>
                <p className="text-white/80">Mets le Congolais au coeur de nos proéccupations.</p>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.section>

       {/* Section mise à jour Festival de l'erdre 2025 */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="py-20 bg-gradient-to-r from-blue-600 to-indigo-700"
      >
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-12 text-white">Festival des Rendez-vous de l’Erdre à Nantes</h2>
          <p className="text-xl text-white/90 mb-12 max-w-3xl mx-auto">
            Du 29 au 31 août 2025, Perspective Congo a participé au festival des Rendez-vous de l’Erdre à Nantes. 
            Depuis 2007, nous y partageons nos saveurs : saka-saka, brochettes, tangawiss et bissap. 
            Malgré la pluie, le public était présent… et nous avons eu l’honneur de recevoir Johanna Rolland,
            maire de Nantes.</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival1bis} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
              {/* <div className="p-6 text-white">
                <h3 className="text-xl font-semibold mb-3">Festival des rendez-vous de l'erdre</h3>
                <p className="text-white/80">Festival des rendez-vous de l'erdre, journée curturelle du Congo, découverte du Congo.</p>
              </div> */}
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival17} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival3} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival4} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival5} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival6} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival7} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival8} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival9} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival10} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival11} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival12} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival13} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival14} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival15} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival16} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={festival2} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt="Événement 1" />
              </div>
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* Nos meilleurs moments Section */}
      {/* <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="py-20 bg-gradient-to-r from-orange-400 to-pink-500"
      >
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-center mb-12 text-white">Nos meilleurs moments</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[...Array(6)].map((_, index) => (
              <motion.div
                key={index}
                whileHover={{ y: -10 }}
                className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl"
              >
                <div className="relative h-64 overflow-hidden">
                  <img src={`event${index + 1}.jpg`} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" alt={`Événement ${index + 1}`} />
                </div>
                <div className="p-6 text-white">
                  <h3 className="text-xl font-semibold mb-3">Découverte du Congo</h3>
                  <p className="text-white/80">Faire connaître le Congo à travers d'un large public.</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section> */}
      <Footer />
    </div>
  );
};

export default Evenement;
